/**
 * Lenis smooth scroll bootstrap — HOMEPAGE ONLY.
 *
 * Loaded ONLY on the index template and ONLY outside the theme editor
 * (gated in layout/theme.liquid → snippets/theme-scripts.liquid). The theme
 * editor dynamically injects sections and auto-scrolls to the selected one, so
 * we must never run a global smooth-scroll there.
 *
 * Behaviour:
 *   - Smooths the MOUSE WHEEL only. Touch scroll stays native (Lenis default;
 *     syncTouch is off), and we additionally gate to (pointer: fine) + desktop
 *     so pure-touch tablets keep native scroll.
 *   - Respects prefers-reduced-motion (no-op when the user opted out).
 *   - Fires real `scroll` events + moves real scrollY, so sticky header,
 *     parallax (scroll-listener) and reveal (IntersectionObserver) keep working.
 *
 * Scroll-lock integration: assets/body-scroll-lock.js calls
 * `window.lenis.stop()/start()` (ref-counted) so the cart drawer, filters,
 * mobile menu, popups and predictive search pause Lenis while open and resume
 * on close — no per-feature wiring needed.
 *
 * Dependencies: @theme/lenis
 */

import Lenis from '@theme/lenis';

const allowed =
  !window.Shopify?.designMode &&
  !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
  window.matchMedia('(min-width: 768px) and (pointer: fine)').matches;

if (allowed) {
  const lenis = new Lenis({
    lerp: 0.1, // glide factor — classic premium feel
    wheelMultiplier: 1,
    smoothWheel: true,
    // Let every in-overlay scroll region (drawers, dropdowns, predictive search —
    // all marked [data-scrollable]) scroll natively. While a drawer is open Lenis
    // is stopped, but its wheel listener still preventDefault()s every wheel event,
    // so without this the drawer body cannot scroll on the homepage.
    prevent: (node) => node.hasAttribute?.('data-scrollable'),
  });

  // Exposed so body-scroll-lock.js can stop/start it (and for debugging).
  window.lenis = lenis;

  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
}
